/**
 * Recipient
 */

//TODO: разные типы получателей взависимости от плательщика

let initRecipientForm = {
    name: '',
    lastName: ''
}

let initContactForm = {
    name: '',
    phone: ''
}

export const recipient = {
    namespaced: true,

    state: () => ({
        recipients: [],
        recipient: {...initRecipientForm},
        contact: {...initContactForm},
    }),

    mutations: {
        setRecipients: (state, payload) => {
            state.recipients = payload.items;
        },
        
        setRecipient: (state, payload) => {
            state.recipient = payload.data;
        },

        resetForm: (state, payload) => {
            state.recipient = {...initForm};
        },
    },
    
    actions: {
        getRecipients: async ({ commit }) => {
            let { data } = await axios.get('/ajax/recipients');

            commit('setRecipients', data);
        },

        getRecipient: ({ commit, dispatch }, payload) => {
            return axios.get('/ajax/recipients/' + payload)
                .then(request => commit('setRecipient', request.data));
        },
    },

    getters: {
    }
}